<template>
  <div>

    <el-row style="height: 40px">
      <el-col>
        备注旗帜：<el-select v-model="sellerFlag" size="mini" style="width: 100px" placeholder="请选择">

        <el-option
          v-for="item in flagOpto"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

        <el-button type="primary" size="small" @click="getMankaData">搜索</el-button>
      </el-col>
    </el-row>
    <el-button type="primary" size="mini" @click="hide">全屏显示/恢复</el-button>
    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px" :data="mankaData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column label="主图"  width="300px">
            <template slot-scope="scope" >
              <img  width="300px" height="300px" :src="scope.row.picPath+'_200x200.jpg'" />
            </template>
          </el-table-column>
          <el-table-column  prop="waikuang" label="外框类型" width="200px"></el-table-column>
          <el-table-column  prop="size" label="尺码" width="200px"></el-table-column>

          <el-table-column  prop="receiverInfo" label="收货人信息" width="240px"></el-table-column>
          <el-table-column  prop="sellerMemo" label="卖家备注" width="160px"></el-table-column>
          <el-table-column  prop="wuliu" label="备注" width="160px"></el-table-column>


        </el-table>
      </el-col>
    </el-row>


  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

  export default {
    name: "ManKa",
    data() {
      return {
        display:1,
        sellerFlag:-1,
        flagOpto:[{value:-1,label:'全部'},{value:0,label:'0-灰色'},{value:1,label:'1-红色'},{value:2,label:'2-黄色'},{value:3,label:'3-绿色'},{value:4,label:'4-蓝色'},{value:5,label:'5-紫色'}],
        mankaData: [],
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 10
        },
      }
    },
    methods: {
      hide:function(){
        this.display++;
        if(this.display % 2 == 0){
          window.document.getElementById("left").style.display = 'none';
          window.document.getElementById("top").style.display = 'none';
        }else {
          window.document.getElementById("left").style.display = 'block';
          window.document.getElementById("top").style.display = 'block';
        }

      },
      indexMethod(index) {
        return index + 1;
      },
      //改变pageSize
      handleSizeChange: function (val) {
        this.pageObject.pageSize = val;
        this.getMankaData();
      },
      //当前页面改变
      handleCurrentChange: function (val) {
        this.pageObject.pageCurrent = val;
        this.getMankaData();
      },
      getMankaData: function () {
        let param = {
          nick: storage.get("nick"),
          sellerFlag: this.sellerFlag,
        }
        $api.post("/custom/manka", param, response => {
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok") {
            this.mankaData = dataResult.data.qianshu;
            let pageObject = dataResult.data.pageObject;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;
          } else {
            this.$message.error(dataResult.message);
            this.$router.replace({name: "Index"});
          }
        })
      }
    },
    mounted() {

      this.getMankaData();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/ManKa.vue